import { Provider }                               from 'mobx-react';
import React                                      from 'react';
import { createBrowserRouter, RouterProvider }   from 'react-router-dom';
import SubjectDetail                              from '../../Subjects/SubjectDetail/Container';
import Welcome                                    from './Welcome';
import { observer, inject }                       from 'mobx-react';

interface DetailPaneProps {
  rootStore: any;
}

const DetailLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="SubjectDetail">
    <div>
      {children}
    </div>
  </div>
);


class DetailPane extends React.Component<DetailPaneProps> {
  render() {
    return (
      <Provider rootStore={this.props.rootStore}>
        <div></div>
      </Provider>
    );
  }
}

export default observer(DetailPane);
/* <Route default component={Welcome} /> */
